// extracted by mini-css-extract-plugin
export default {"root":"AllInOneSection_root__UJ0Bq"};